import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import CustomSelect from "../CustomSelect/CustomSelect.component";
import { setLoginStatus, logout } from '../../redux/features/authHandler.feature';

import { FaRegBell } from "react-icons/fa";
import HeaderNotification from "../HeaderNotification.component";
import ReactImageFallback from "react-image-fallback";
import { toast, ToastContainer } from "react-toastify";

// images
import logoLight from "../../assets/images/logo-light.png";
import defaultUser from '../../assets/images/default_profile_pic.jpg';

export default function Header2() {
  const dispatch = useDispatch();
  const [message, setMessage] = useState("");
  const [searchPopup, setSearchPopup] = useState(false);
  
  // Redux State Values
  const islogin = useSelector((state) => state?.auth?.isLogin);
  const token = useSelector(state => state.auth.token);
  const data = useSelector(state => state.auth.data);
  // set login state in redux
  
  if (token.length < 1 && Object.keys(data).length < 1) {
    dispatch(setLoginStatus(false));
  } else {
    dispatch(setLoginStatus(true));
  }
  
  useEffect(() => {
    if(Object.keys(message).length > 0){
      toast.error(message.msg);
    }
  }, [message]);

  //   logout
  const logoutHandler = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/logout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({
        device_id: 1548788500,
      }),
    })
      .then((r) => r.json())
      .then((response) => {
        // console.log(response);
        if (response.success) {
          // console.log("Logout Message");
          dispatch(logout());
          <Navigate to="/signin" replace />
        }
      });
  };

  

  const options = [
    { value: 'painting', label: 'Painting' },
    { value: 'carpet cleaning', label: 'Carpet Cleaning' },
    { value: 'cleaning', label: 'Cleaning' },
    { value: 'landscapting', label: 'Landscapting' },
    { value: 'drywall repair', label: 'Drywall Repair' },
    { value: 'pressure washing', label: 'Pressure Washing' }
  ]
  const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      // const color = chroma(data.color);
      // console.log({ data, isDisabled, isFocused, isSelected });
      return {
        ...styles,
        backgroundColor: isFocused || isSelected ? "#0eb2ef" : null,
        color: isFocused || isSelected ? "#fff" : "#000"
      };
    }
  };

  return (
    <>
      {/* <!-- HEADER START --> */}
      <header className="container">
        <div className={`navbar navbar-expand-lg bds-navbar bds-navbarv3  ${searchPopup ? 'bds-searchopen' : ''} `}>
          <div className="container-fluid">
             <Link to="/" className="navbar-brand" >
                <strong>
                  <img
                    src={logoLight}
                    alt="3bids logo"
                    className="header-logo"
                    width={80}
                    height={80}
                  />
                </strong>
            </Link>
            {/* <div className="bds-appendinput">
              <div className="bds-searcbar">
                <div className="bds-inputicon">
                 <Link to="#">
                    <i className="icon-search"></i>
                  </Link>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="What are you looking for?"
                  />
                </div>
                <div className="d-flex w-75 align-items-center mx-3">
                  <i className="icon-layers"></i>
                  <CustomSelect
                    // defaultValue={options[3]}
                    options={options}
                    className="customSelectContainer w-100 ms-2"
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    styles={colourStyles}

                  />

                </div>
                 <Link to="/signin" className="bds-btn-solid bds-darkbtn">
                    Search now
                </Link>
                <div className="bds-formcloseicon">
                  <button type="button" className="btn" onClick={() => setSearchPopup(false)}>
                    <i className="icon-x"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="bds-formicon header__search">
              
              <button type="button" onClick={() => setSearchPopup(true)} className="bds-btn-solid-sm bds-btn-yellow btn">
                  <i className="icon-search ps-0"></i>
              </button>
            </div> */}
            
            <div className="bds-navbar-right header_right_menu ms-auto">
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="icon-menu"></span>
              </button>
              <nav className="collapse navbar-collapse" id="navbarNav">

                <ul className="navbar-nav bds-navbar-nav">
                  {/* <li>
                     <Link to="/">
                      <a>Home</a>
                    </Link>
                  </li> */}
                  <li>
                     <Link to="/">
                      Home
                    </Link>
                  </li>
                  <li>
                     <Link to="/my-jobs">
                      My Jobs
                    </Link>
                  </li>
                  <li>
                     <Link to="/jobs">
                      Job Listings
                    </Link>
                  </li>
                  {/* <li>
                     <Link to="/freelancers-list">
                      <a>Find Talent</a>
                    </Link>
                  </li> */}
                  {!islogin && (
                    <li className="d-lg-none d-block">
                       <Link to="/signin">
                        Signin/Signup
                      </Link>
                    </li>
                  )}
                </ul>
              </nav>
                {
                  islogin &&
                <div className="header_user">
                    <ul className="ps-0 d-flex align-items-center justify-content-center">
                      <li className="dropdown notification_container">
                        <button
                          type="button"
                          data-bs-toggle="dropdown"
                          className="btn position-relative p-0 shadow-none text-white"
                        >
                          <FaRegBell size="20px" />
                          <span className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle">
                            <span className="visually-hidden">New alerts</span>
                          </span>
                        </button>
                        <div className="dropdown-menu rounded-2 border-0 shadow-lg  p-0 notification-dropdown">

                          <HeaderNotification
                            setMessage={setMessage}
                          />

                          <Link to="/notifications" className="btn text-white bds-btn-solid w-100">
                            View All
                          </Link>
                        </div>
                      </li>
                      <li className="dropdown">
                        <button
                          className="btn p-0 d-flex align-items-center shadow-none"
                          data-bs-toggle="dropdown"
                        >
                          <ReactImageFallback
                            src={`https://3bidsapp.com/dev/public/storage/${data?.profile_image}`}
                            fallbackImage={defaultUser}
                            initialImage={defaultUser}
                            alt="user image"
                            width={40}
                            height={40}

                            className="rounded-circle bg-secondary header_profile_img"
                          />

                        </button>
                        <ul className="nav flex-column">

                        </ul>

                        <ul className="dropdown-menu rounded-2 border-0 shadow-lg flex-column profile-menu-dropdown">
                          <li className=" nav-item">
                            <Link to="/profile" className="nav-link fw-normal">Profile
                            </Link>
                          </li>
                          <li className=" nav-item">
                            <Link to="/my-jobs" className="nav-link fw-normal">My Jobs
                            </Link>
                          </li>
                          <li className=" nav-item">
                            <Link to="/notifications" className="nav-link fw-normal">Notifications
                            </Link>
                          </li>
                          <li className=" nav-item">
                            <Link to="/chat" className="nav-link fw-normal">Chat
                            </Link>
                          </li>
                          <li className=" nav-item">
                            <Link to="#" className="nav-link fw-normal" onClick={() => logoutHandler()}>Log Out
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                </div>
                }
            </div>
            <div className="bds-navbarbtn me-sm-3">
            {
              data?.role == 3 && 
                 <Link to={`${islogin ? "/create-job" : "/signin"}`} className="bds-btn-solid-lg bds-btn-yellow">Post a Job
                </Link>
            }
            {
              !islogin && 
                 <Link to={`${islogin ? "/create-job" : "/signin"}`} className="bds-btn-solid-lg bds-btn-yellow">Post a Job
                </Link>
            }
            </div>
            {!islogin && (
              <div className="bds-navbarbtn d-sm-block d-none">
                 <Link to="/signin"  className="bds-btn-solid-lg bds-btn-yellow">Signin/Register
                </Link>
              </div>
            )}
          </div>
        </div>
      </header>
      {/* <!-- HEADER END --> */}
      <ToastContainer />
    </>
  );
}
